import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'app-input-data-taxi',
  templateUrl: './input-data-taxi.component.html',
  styleUrls: ['./input-data-taxi.component.css']
})
export class InputDataTaxiComponent implements OnInit {
  matricula: string;
  constructor(private msg : ToastService,
    public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

  ngOnInit(): void {    
    this.matricula = this.config.data.matricula;
  }

  sendMatricula(){
    if(this.validate){
      this.msg.showWarn("Introduce una matrícula.");
      return;
    }    
    this.ref.close(this.matricula);
  }

  get validate() : string{
    var text = this.matricula;
    if(!text || text.trim() == ""){
      return "Introduce una matrícula.";
    }

    if(text.length > 10){
      return "La matrícula es demasiado larga."
    }
  }

}
